import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { RegistrationServiceLocation } from "../../../../../../models/registration-service-location";

@Component({
  selector: "select-collection-place",
  templateUrl: "./select-collection-place.component.html",
})
export class RegistrationLocationSelectionComponent {
  @Input() public items: RegistrationServiceLocation[] = [];
  @Input() public selectedItem: RegistrationServiceLocation;
  @Output() public isSelected = new EventEmitter();
  @Output() public createNew = new EventEmitter();

  public getSelectedItemId(): string {
    if (this.selectedItem) {
      return this.selectedItem.id;
    } else {
      return "";
    }
  }

  public updateSelectedValue(id: string): void {
    this.selectedItem = this.items.find((myObj) => myObj.id === id);
    this.isSelected.emit(this.selectedItem);
  }

}
